export default __webpack_public_path__ + "static/media/March2011.af9e1192.png";